export default __webpack_public_path__ + "static/media/steam.ee217786.svg";